module.exports = __webpack_public_path__ + "media/dogs/dog-eating-from-bowl--yellow-a4d3f25e.svg";